import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { generateRandomString } from "js/helpers/header";
import Switch from "@mui/material/Switch";
import lockedIcon from "images/Locked_icon.png";
import unlockedIcon from "images/Unlocked_icon.png";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import { Button } from '../../../Component/CommonFormEle';
import {
    fetchPolicyGroupSettings,
    updatePolicyGroupSetting,
    updatePolicySettingLock
} from "js/Api/index";

function ClockSettingsTab({ user, policy, settingsFrom }) {
    const [settings, setSettings] = useState([]);
    const [showClockAfterInactivity, setShowClockAfterInactivity] = useState(false);
    const [clockSettingCategoryGroups, setClockSettingCategoryGroups] = useState([]);
    const [selectedClockOption, setSelectedClockOption] = useState("allow");

    const isReadOnly = selectedClockOption !== "manage";

    useEffect(() => {
        fetchClockSettings();
    }, []);

    const fetchClockSettings = async () => {
        try {
            const response = await fetchPolicyGroupSettings(policy.id);

            if (response.success) {
                setSettings(response.data.polictSettings);
                setClockSettingCategoryGroups(response.data.policySettingCategoryGroups);
                updateClockState(response.data.polictSettings);
                updateSelectedClockOption(response.data.policySettingCategoryGroups);
            } else {
                console.error("Failed to fetch Clock settings:", response.error);
            }
        } catch (error) {
            console.error("Error fetching Clock settings:", error);
        }
    };

    const updateClockState = (clockSettings) => {
        clockSettings.forEach((setting) => {
            if (setting.name === "Show clock after inactivity") {
                setShowClockAfterInactivity(setting.value === "true");
            }
        });
    };

    const updateSelectedClockOption = (categoryGroups) => {
        const clockCategory = categoryGroups.find(
            (category) => category.categoryName === "Clock"
        );
        if (clockCategory) {
            setSelectedClockOption(clockCategory.locked ? "manage" : "allow");
        }
    };

    const handleSaveClock = async () => {
        const updatedSettings = settings
            .filter((setting) => setting.name === "Show clock after inactivity")
            .map((setting) => ({
                ...setting,
                value: showClockAfterInactivity.toString()
            }));

        try {

            let hasError = false;

            for (const setting of updatedSettings) {
                const response = await updatePolicyGroupSetting(policy.id, setting.id, setting.value);

                if (!response.success) {
                    console.error(`Failed to update setting ${setting.name}:`, response.error);
                    hasError = true;
                }
            }

            if (hasError) {
                toast.error("Failed to update Clock settings");
            } else {
                toast.success("Clock settings updated successfully!");
                fetchClockSettings();
            }
        } catch (error) {
            console.error("Error updating Clock settings:", error);
            toast.error("Failed to update Clock settings");
        }
    };

    const handleCategoryLockChange = async (locked) => {
        const category = clockSettingCategoryGroups.find(
            (category) => category.categoryName === "Clock"
        );

        if (!category) return;

        try {
            const response = await updatePolicySettingLock(policy.id, category.id, locked);

            if (response.success) {
                // Update local state
                category.locked = locked;
                setClockSettingCategoryGroups([...clockSettingCategoryGroups]);
                setSelectedClockOption(locked ? "manage" : "allow");
            } else {
                console.error("Failed to update category lock:", response.error);
                toast.error("Failed to update category lock");
            }
        } catch (error) {
            console.error("Error updating category lock:", error);
            toast.error("Failed to update category lock");
        }
    };


    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <h4 className="d-inline">Clock</h4>
                    <div className="dropdown d-inline">
                        <button
                            className="btn lockerBtn"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {selectedClockOption === "allow" ? (
                                <img src={unlockedIcon} style={{ height: "20px" }} />
                            ) : (
                                <img src={lockedIcon} style={{ height: "20px" }} />
                            )}
                        </button>
                        <ul className="dropdown-menu dropdown-item-ul">
                            <li onClick={() => handleCategoryLockChange(false)}>
                                <span>
                                    <LockOpenRoundedIcon
                                        sx={{
                                            width: "20px",
                                            margin: "0 5px",
                                        }}
                                    />
                                </span>
                                Allow device user and family to change these settings
                                {selectedClockOption === "allow" && (
                                    <span style={{ float: "right", marginRight: "1em" }}>
                                        <DoneRoundedIcon />
                                    </span>
                                )}
                            </li>
                            <li onClick={() => handleCategoryLockChange(true)}>
                                <span>
                                    <LockRoundedIcon
                                        sx={{
                                            width: "20px",
                                            margin: "0px 5px",
                                        }}
                                    />
                                </span>
                                Organisation manages these settings
                                {selectedClockOption === "manage" && (
                                    <span style={{ float: "right", marginRight: "1em" }}>
                                        <DoneRoundedIcon />
                                    </span>
                                )}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-md-3">
                    Show clock after inactivity
                </div>
                <div className="col-md-9">
                    <Switch
                        checked={showClockAfterInactivity}
                        onChange={(e) => setShowClockAfterInactivity(e.target.checked)}
                        color="primary"
                        disabled={isReadOnly}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Button onClick={handleSaveClock} variant="black">
                        Apply
                    </Button>
                </div>
            </div>
        </>
    );
}

export default ClockSettingsTab;